import React from 'react';
import "../../../styles/timelineLegend.scss";

const TimelineLegend = () => {
  return (
    <div id="TimelineLegend">
        <div className="legend-container">
            <div className="legend-labels">
                <span>Journey Start</span>
                <span>End</span>
            </div>
            <div className="gradient-line"/>
        </div>
    </div>
  );
};

export default TimelineLegend;
